import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';
import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

export const ADMIN_ORGANIZATIONS_ROOT = `${BASE_ADMIN_V2_PATH}/organizations`;
export const ADMIN_ORGANIZATIONS_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/organizations`;

export const ADMIN_ORGANIZATIONS_APP_PATHS = {
  ORGANIZATIONS_LIST: `${ADMIN_ORGANIZATIONS_ROOT}`,
  ORGANIZATION_DETAILS: `${ADMIN_ORGANIZATIONS_ROOT}/:organizationId`,
  ORGANIZATION_CREATE_ORDER: `${ADMIN_ORGANIZATIONS_ROOT}/:organizationId/create-order`,
};

export const ORGANIZATION_CREATE_ORDER_PATH = (organizationId: string, userId?: string) =>
  `${ADMIN_ORGANIZATIONS_ROOT}/${organizationId}/create-order${userId ? `?userId=${userId}` : ''}`;

export const ADMIN_ORGANIZATIONS_API_PATHS = {
  GET_ORGANIZATIONS: `${ADMIN_ORGANIZATIONS_API_ROOT}`,
  CREATE_ORGANIZATION: `${ADMIN_ORGANIZATIONS_API_ROOT}`,
  GET_ORGANIZATION_BY_ID: (organizationId: string) => `${ADMIN_ORGANIZATIONS_API_ROOT}/${organizationId}`,
  UPDATE_ORGANIZATION: (organizationId: string) => `${ADMIN_ORGANIZATIONS_API_ROOT}/${organizationId}`,
};
